module.exports = __webpack_public_path__ + "assets/img/34_776_big.f5e7d924.jpg";